exports.baseURL = process.env.REACT_APP_API_BASE_URL || "https://admin.rajpatelkinglive.com/";
exports.key = process.env.REACT_APP_API_KEY || "";
exports.projectName = ""
